import React from "react";
import { IMdaePopupFooterEndButtons } from "./index";
import "./index.scss";
const MdaePopupFooterEndButtons: React.FC<IMdaePopupFooterEndButtons> = (
  props
) => {
  return <div id={props.id} style={props.style} className={"mdae-popup-end-buttons"}>{props.children}</div>;
};
export { MdaePopupFooterEndButtons };
